/*
 * Availability notice（在庫なし理由注記）のバリアント切替追従
 * 正本は docs/pdp_availability_status.md。
 *
 * product-info.js はバリアント切替時に Section Rendering API で再描画 HTML を取得し、
 * toggleSubmitButton(disabled, variantStrings.soldOut) でボタン文言を書き換えたあと、
 * variant-change イベントを再描画 HTML 付きで同期 publish する（Rise 本体・無改変）。
 * この文言書き換えは在庫なし＝「在庫なし」の一律固定で、availability status の
 * 分岐ラベル（近日発売・完売）を潰してしまうため、本 JS が variant-change を購読し
 * サーバー描画（buy-buttons.liquid の分岐結果）を正としてラベルを復元する。
 * disabled 属性も同様にサーバー描画を正として復元する。toggleSubmitButton は在庫あり
 * バリアントでボタンを有効化するため、在庫あり×未発売カラー（coming_soon はカラー粒度
 * オーバーライドあり・在庫より優先でボタンを閉じる仕様）への切替時、ラベルだけ
 * 「近日発売」で押せるボタンになる事故をここで防ぐ。
 * 注記本体も同 HTML から同 id の要素を転写し、選択バリアントの在庫状態に応じた
 * 表示/非表示（restock_planned / discontinued は在庫なしのときだけ出す）へ追従させる。
 *
 * publish は同期呼び出しのため、toggleSubmitButton の上書きと本 JS の復元は同一
 * タスク内で完結し、描画フレームに中間状態（在庫なし表示）が漏れることはない。
 * Sticky ATC は メイン CTA の MutationObserver ミラー（sticky-atc.js）なので、
 * ここでメインボタンを直せばバーにも自動追従する。
 *
 * 本スニペットは main-product と featured-product の両方から読み込まれうるため、
 * 二重 define を customElements.get でガードする。
 */
if (!customElements.get('availability-notice')) {
  customElements.define(
    'availability-notice',
    class AvailabilityNotice extends HTMLElement {
      connectedCallback() {
        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const { sectionId, html } = event.data;
          if (sectionId !== this.dataset.section) return;

          const source = html.getElementById(this.id);
          if (source) {
            this.innerHTML = source.innerHTML;
            this.classList.toggle('hidden', source.classList.contains('hidden'));
            // 再入荷通知ボタンの抑止フラグ（完売 or 購入可能）も同期転写する。
            // CTA 文言復元と同一の同期タスク内で反映されるため、ボタンの出没が
            // パネル再描画とフレーム同期する（アプリ側トグルの遅延を顧客に見せない）。
            this.toggleAttribute('data-bis-suppressed', source.hasAttribute('data-bis-suppressed'));
          }

          const sourceButton = html.getElementById(`ProductSubmitButton-${sectionId}`);
          const button = document.getElementById(`ProductSubmitButton-${sectionId}`);
          if (sourceButton && button) button.toggleAttribute('disabled', sourceButton.hasAttribute('disabled'));
          const sourceLabel = sourceButton && sourceButton.querySelector('span');
          const label = button && button.querySelector('span');
          if (sourceLabel && label) label.textContent = sourceLabel.textContent.trim();
        });
      }

      disconnectedCallback() {
        if (this.unsubscribeVariantChange) this.unsubscribeVariantChange();
      }
    }
  );
}
